import { FieldType, FieldTypeType, OptionType, Unit } from "./types";
import { TFunction } from "i18next";

export const getTextField = (t: TFunction) => {
  const TEXT_FIELD: FieldType = {
    fieldID: 1,
    name: t("textInput"),
    position: 1,
    type: FieldTypeType.Text,
    noteOption: false,
    defaultValue: t("textInput"),
    options: [],
    tabID: 0,
    placeholder: t("textInput"),
    value: t("textInput"),
  };
  return TEXT_FIELD;
};

export const getNumberField = (t: TFunction) => {
  const NUMBER_FIELD: FieldType = {
    fieldID: 2,
    name: t("numberInput"),
    position: 2,
    type: FieldTypeType.Number,
    noteOption: false,
    defaultValue: "1",
    options: [],
    tabID: 0,
    placeholder: "",
    value: "1",
    unit: Unit.Day,
  };
  return NUMBER_FIELD;
};

export const getNumberNumberField = (t: TFunction) => {
  const NUMBER_NUMBER_FIELD: FieldType = {
    fieldID: 3,
    name: t("numberNumberInput"),
    position: 3,
    type: FieldTypeType.NumberNumber,
    noteOption: false,
    defaultValue: "1",
    options: [],
    tabID: 0,
    placeholder: "",
    value: 1,
    unit: "day,hours" as Unit,
  };
  return NUMBER_NUMBER_FIELD;
};

export const getBooleanTextField = (t: TFunction) => {
  const BOOLEAN_TEXT_FIELD: FieldType = {
    fieldID: 4,
    name: t("booleanTextField"),
    position: 4,
    type: FieldTypeType.BooleanText,
    noteOption: false,
    defaultValue: t("booleanTextFieldDefaultValue"),
    options: [],
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return BOOLEAN_TEXT_FIELD;
};

const getOptions = (t: TFunction) => {
  const OPTIONS: OptionType[] = [
    {
      name: t("option1"),
      value: t("option1"),
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: t("option2"),
      value: t("option2"),
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
    {
      name: t("option3"),
      value: t("option3"),
      position: 3,
      optionID: 2,
      fieldID: 4,
    },
    {
      name: t("option4"),
      value: t("option4"),
      position: 4,
      optionID: 3,
      fieldID: 4,
    },
    {
      name: t("option5"),
      value: t("option5"),
      position: 5,
      optionID: 4,
      fieldID: 4,
    },
  ];
  return OPTIONS;
};

export const getSelectField = (t: TFunction) => {
  const options = getOptions(t);
  const SELECT_FIELD: FieldType = {
    fieldID: 5,
    name: t("selectField"),
    position: 5,
    type: FieldTypeType.Select,
    noteOption: false,
    defaultValue: t("option1"),
    options: options,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return SELECT_FIELD;
};

export const getMultiSelectField = (t: TFunction) => {
  const options = getOptions(t);
  const MULTI_SELECT_FIELD: FieldType = {
    fieldID: 6,
    name: t("multiSelectField"),
    position: 6,
    type: FieldTypeType.MultipleChoice,
    noteOption: false,
    defaultValue: `${t("option2")}|${t("option4")}`,
    options: options,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return MULTI_SELECT_FIELD;
};

export const getCascaderField = (t: TFunction) => {
  const OPTIONS_WITH_SUB_OPTIONS: OptionType[] = [
    {
      name: t("option1"),
      value: t("option1"),
      position: 1,
      optionID: 0,
      fieldID: 4,
      subOptions: [
        {
          name: t("suboption1"),
          value: t("suboption1"),
          position: 1,
          optionID: 0,
          subOptionID: 0,
        },
        {
          name: t("suboption2"),
          value: t("suboption2"),
          position: 2,
          optionID: 1,
          subOptionID: 1,
        },
      ],
    },
    {
      name: t("option2"),
      value: t("option2"),
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
    {
      name: t("option3"),
      value: t("option3"),
      position: 3,
      optionID: 2,
      fieldID: 4,
      subOptions: [
        {
          name: t("suboption3"),
          value: t("suboption3"),
          position: 1,
          optionID: 0,
          subOptionID: 2,
        },
        {
          name: t("suboption4"),
          value: t("suboption4"),
          position: 2,
          optionID: 1,
          subOptionID: 3,
        },
      ],
    },

    {
      name: t("option4"),
      value: t("option4"),
      position: 4,
      optionID: 3,
      fieldID: 4,
    },
    {
      name: t("option5"),
      value: t("option5"),
      position: 5,
      optionID: 4,
      fieldID: 4,
    },
  ];
  const CASCADER_FIELD: FieldType = {
    fieldID: 7,
    name: t("cascaderField"),
    position: 7,
    type: FieldTypeType.Cascader,
    noteOption: false,
    defaultValue: `${t("option1")} - ${t("suboption2")}; ${t("option4")}`,
    // defaultValue: "Možnosť 1 - Podmožnosť 2",
    options: OPTIONS_WITH_SUB_OPTIONS,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return CASCADER_FIELD;
};

export const getButtonGroupField = (t: TFunction) => {
  const SMALL_OPTIONS: OptionType[] = [
    {
      name: t("option1"),
      value: t("option1"),
      position: 1,
      optionID: 0,
      fieldID: 4,
    },
    {
      name: t("option2"),
      value: t("option2"),
      position: 2,
      optionID: 1,
      fieldID: 4,
    },
  ];

  const BUTTONGROUP_FIELD: FieldType = {
    fieldID: 8,
    name: t("buttonGroupField"),
    position: 8,
    type: FieldTypeType.ButtonGroup,
    noteOption: false,
    defaultValue: t("option1"),
    options: SMALL_OPTIONS,
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return BUTTONGROUP_FIELD;
};

export const getBooleanField = (t: TFunction) => {
  const BOOLEAN_FIELD: FieldType = {
    fieldID: 9,
    name: t("booleanField"),
    position: 9,
    type: FieldTypeType.Boolean,
    noteOption: false,
    defaultValue: "false",
    options: [],
    tabID: 0,
    placeholder: "",
    value: "false",
  };
  return BOOLEAN_FIELD;
};

export const getStaticTextField = (t: TFunction) => {
  const STATIC_TEXT_FIELD: FieldType = {
    fieldID: 10,
    name: t("staticTextField"),
    position: 10,
    type: FieldTypeType.StaticText,
    noteOption: false,
    defaultValue: t("staticTextFieldValue"),
    options: [],
    tabID: 0,
    placeholder: "",
    value: t("staticTextFieldValue"),
  };
  return STATIC_TEXT_FIELD;
};

export const getButtonField = (t: TFunction) => {
  const BUTTON_FIELD: FieldType = {
    fieldID: 11,
    name: t("buttonField"),
    position: 11,
    type: FieldTypeType.Button,
    noteOption: false,
    defaultValue: t("buttonFieldValue"),
    options: [],
    tabID: 0,
    placeholder: "",
    value: t("buttonFieldValue"),
  };
  return BUTTON_FIELD;
};

export const getUrineField = (t: TFunction) => {
  const URINE_FIELD: FieldType = {
    fieldID: 12,
    name: t("urineField"),
    position: 12,
    type: FieldTypeType.Urine,
    noteOption: false,
    defaultValue: t("notDone"),
    options: [],
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return URINE_FIELD;
};

export const getBMICalculatorField = (t: TFunction) => {
  const BMI_FIELD: FieldType = {
    fieldID: 13,
    name: t("bmiCalculator"),
    position: 13,
    type: FieldTypeType.BMICalculator,
    noteOption: false,
    defaultValue: "",
    options: [],
    tabID: 0,
    placeholder: "",
    value: "",
  };
  return BMI_FIELD;
};
